import * as React from 'react';
import { NavLink, Link } from 'react-router-dom';
import Form from '../components/FormGenerator/Form';
import {
  Title,
  Section,
  Container,
  Button,
  Nav,
  Breadcrumbs,
  Icon,
  IconText,
  Jumbotron
} from '../modules/modules';
import { contactFields } from '../formFields';
import { INavLink } from '../interfaces/interfaces';

const breadcrumbsLinks: INavLink[] = [
  { value: 'Úvod' }, 
  { value: 'Kontakty' }
];

interface IUserPasswordState {
  formFields: any[];
  formValues: any;
}

class Contact extends React.Component {
  public state: IUserPasswordState;
  constructor(props: {}) {
    super(props);
    this.state = {
      formFields: contactFields,
      formValues: {}
    };
  }

  public handleChange = (value: any, field: string) => {
    this.setState({ formValues: { ...this.state.formValues, [field]: value } });
  }

  public setFormState = (fields: any) => {
    this.setState({ fields });
  }

  public handleSend(form: any) {

    form.validate((fields: any) => {
      this.setFormState(fields);
    });
  }

  public render() {
    return (
      <React.Fragment>
        <Jumbotron background="/img/contact-jumbo.jpg">Kontakt</Jumbotron>
        <Section type="jumbo">
          <Container type="md">
            <div className="boundaries">
              <div className="text-light">
                <Breadcrumbs links={breadcrumbsLinks} />
                <Title type="afterBread">Kontakty a zákaznická podpora</Title>
                <div className="grid grid--contact pt-sm-3">
                  <div className="grid__item">
                    <div className="visible-xs">
                      <Title type="sm">{process.env.REACT_APP_PROJECT_NAME}</Title>
                    </div>
                    <div className="text-lg">
                      <div className="visible-sm">
                        <p>
                          Máte dotaz, potřebujete poradit nebo se chcete na něco
                          zeptat? Rádi Vám poradíme jak zvolit správnou obuv
                        </p>
                        <p>i vybavení na basketbal.</p>
                        <p>Těšíme se na Vás</p>
                      </div>
                      <p className="hidden-sm">
                        Máte dotaz, potřebujete poradit nebo se chcete na něco zeptat? Rádi Vám poradíme jak zvolit správnou obuv
                        <br/>i vybavení na basketbal.
                        <br/>Těšíme se na Vás
                      </p>
                      <b>Ondřej Jelínek a David Sláma</b>
                      <IconText icon="phone" type="contact">
                        <React.Fragment>
                          <b>(+420) 608 223 688 </b>
                          Dotazy vyřizujeme od 10 - 17h
                        </React.Fragment>
                      </IconText>
                      <IconText icon="envelope" type="contact">
                        <React.Fragment>
                          <b>info@basket-obchod.cz</b>
                        </React.Fragment>
                      </IconText>
                      <IconText icon="gps" type="contact">
                        <React.Fragment>
                          <b>Rosolova 715/ Pelhřimov 39301</b>
                          Adresa provozovatele, nejedná se o adresu obchodu.
                        </React.Fragment>
                      </IconText>
                      <p className="mt-2">
                        <table className="table table--text table--pt">
                          <tbody>
                            <tr>
                              <td>Č.Ú:</td>
                              <td>
                                670100-2207847355/6210 mBank 
                                <div className="hidden-xs"/>( BRE Bank S.A.)
                                </td>
                            </tr>
                            <tr>
                              <td>IČ:</td>
                              <td>74737198</td>
                            </tr>
                            <tr>
                              <td>DIČ:</td>
                              <td>CZ8404161502</td>
                            </tr>
                          </tbody>
                        </table>
                        {/* Č.Ú: 670100-2207847355/6210 mBank ( BRE Bank S.A.)
                        <br />IČ: 74737198
                        <br />DIČ: CZ8404161502 */}
                      </p>
                    </div>
                  </div>
                  <div className="grid__item">
                    <div className="form form--contact">
                      <div className="form__title">Kontaktní formulář</div>
                      <Form
                        fields={this.state.formFields}
                        values={this.state.formValues}
                        handleChange={this.handleChange}
                      >
                        {(form: any) => {
                          return (
                            <Button
                              onClick={() => {
                                this.handleSend(form);
                              }}
                            >
                              Odeslat
                            </Button>
                          );
                        }}
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </Section>
        {/* <Stores /> */}
      </React.Fragment>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/pages/Contact.tsx